var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[( _vm.id > 84)?_c('ItcDetail'):_c('RoutineDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }